export enum ZoneTypeId {
  TriggerNode = 1,
  LightNode = 2,
}
